import React from 'react';
import { Route, Switch } from "react-router-dom";
import IssuerListingCalendarMain from './listing-calendar/listing-calendar-main';

const IssuerListingCalendar = () => {
  return (
    <Switch>
      <Route exact path="/listing-calendar">
        <IssuerListingCalendarMain />
      </Route>
    </Switch>
  )
}

export default IssuerListingCalendar;
